import axios from 'axios';

const DeleteBlogApi = (id) => {
	return axios.delete(
		`https://backend.planmyleisure.com/blog/delete-blog/${id}`
	);
};
export default DeleteBlogApi;
